import { Outlet } from "react-router";
import { TabNavigation } from "./TabNavigation";
import { ActiveTripBanner } from "./ActiveTripBanner";
import { LocationStatusBar } from "./location-status-bar/location-status-bar";
import { useActiveTrip } from "@/hooks/useActiveTrip";

/**
 * Chrome for the tab app: status bar, active-trip banner, and the bottom tab
 * navigation around the matched tab route. The idle Location Landing renders
 * *outside* this layout so it stays full-screen with no tab bar. The location
 * permission context is provided one level up by <RootLayout>.
 */
export default function TabLayout() {
  // For now, hardcode variant to 'clean' (light mode)
  // Future: get this from a ThemeContext or user preferences
  const variant = "clean";
  const { activeTrip } = useActiveTrip();

  return (
    <div className="pt-[env(safe-area-inset-top,0px)]">
      <LocationStatusBar />
      {/* Main content area — clears the fixed tab bar, the active-trip banner
          when shown, and the home-indicator inset (heights: spacing.css) */}
      <div
        className={
          activeTrip
            ? "pb-[calc(var(--tab-navigation-height)+var(--active-trip-banner-height)+env(safe-area-inset-bottom,0px))]"
            : "pb-[calc(var(--tab-navigation-height)+env(safe-area-inset-bottom,0px))]"
        }
      >
        <Outlet />
      </div>

      <ActiveTripBanner />

      {/* Fixed bottom tab navigation */}
      <TabNavigation variant={variant} />
    </div>
  );
}
